import React, { useEffect, useState } from "react";
import CustomTable from "../../../shared/custom-table/custom-table";
import { columnsAds } from "../../../mocks/fakeData";
import {
  Modal,
  IconButton,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faCheckCircle, 
  faEye, 
  faEyeSlash, 
  faTriangleExclamation 
} from "@fortawesome/free-solid-svg-icons";
import {
  getUserGroupService,
  makePublicGroupService,
} from "../../../services/group-service";

const Advertisement = () => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [profileData, setProfileData] = useState<any[]>([]);
  const [status, setStatus] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("Privée");

  useEffect(() => {
    getUserGroupService()
      .then((res) => {
        setProfileData(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const handleDeleteClick = (status: boolean, title: string, row: any) => {
    setSelectedRow(row);
    setStatus(status);
    setTitle(title);
    setOpenDeleteDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedRow(null);
  };

  const handleConfirm = () => {
    makePublicGroupService(selectedRow.id, status).then((res) => {
      getUserGroupService()
        .then((res) => {
          setProfileData(res.data);
        })
        .catch((e) => {
          console.log(e);
        });
      handleCloseDialog();
      setSelectedRow(null);
    });
  };

  const ActionButtons: React.FC<{ row: any }> = ({ row }) => (
    <div className="flex items-center justify-center space-x-2">
      <button
        onClick={() => handleDeleteClick(true, "Public", row)}
        className="bg-primary px-2 py-1 text-white rounded"
      >
        Rendre le groupe public
      </button>
      <button
        onClick={() => handleDeleteClick(false, "Privée", row)}
        className="bg-red text-white px-2 py-1 rounded"
      >
        Rendre le groupe Privée
      </button>
    </div>
  );

  const renderActions = (row: any) => <ActionButtons row={row} />;
  const ActionButtonsStatus: React.FC<{ row: any }> = ({ row }) => (
    <p className="font-montserrat_regular text-title">
      {row.isPublic ? "Public" : "Privé"}
    </p>
  );

  const renderActionsStatus = (row: any) => <ActionButtonsStatus row={row} />;

  return (
    <div className="p-10">
      <div className="w-full flex justify-between items-center mb-5">
        <h1 className="text-title font-montserrat_bold  text-3xl">Publicité</h1>
        <div></div>
      </div>
      <CustomTable
        title="Gérer Publicités"
        columns={columnsAds}
        data={profileData}
        actions={renderActions}
        status={renderActionsStatus}
        statusName={"Status"}
      />
      <AnimatePresence>
        {openDeleteDialog && (
          <Modal
            open={openDeleteDialog}
            onClose={handleCloseDialog}
            className="flex items-center justify-center p-4 backdrop-blur-xl bg-title/40"
            closeAfterTransition
          >
            <motion.div 
              className="w-full max-w-[450px] bg-white rounded-[3rem] p-10 shadow-3xl text-center outline-none border border-white/20"
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
            >
              <div className={`w-24 h-24 rounded-[2.5rem] flex items-center justify-center text-4xl mx-auto mb-8 border shadow-sm relative ${status ? 'bg-emerald-50 text-emerald-500 border-emerald-100' : 'bg-rose-50 text-rose-500 border-rose-100'}`}>
                <div className={`absolute inset-0 rounded-[2.5rem] animate-ping opacity-50 ${status ? 'bg-emerald-400/20' : 'bg-rose-400/20'}`}></div>
                <FontAwesomeIcon icon={status ? faEye : faEyeSlash} className="relative z-10" />
              </div>
              
              <h3 className="text-2xl font-black text-title uppercase tracking-tight mb-4">
                Visibilité du <span className={status ? 'text-emerald-500' : 'text-rose-500'}>Groupe</span>
              </h3>
              
              <p className="text-sm font-medium text-text/60 leading-relaxed mb-10 px-4">
                Voulez-vous rendre ce groupe <span className="text-[#05322B] font-black">{title}</span> ?
              </p>

              <div className="flex gap-4">
                <button
                  className="flex-1 h-16 bg-slate-50 text-text/40 font-black text-[11px] uppercase tracking-widest rounded-2xl hover:bg-slate-100 transition-all duration-300 outline-none"
                  onClick={handleCloseDialog}
                >
                  Annuler
                </button>
                <button
                  className={`flex-1 h-16 text-white font-black text-[11px] uppercase tracking-widest rounded-2xl shadow-xl transition-all duration-300 outline-none ${status ? 'bg-emerald-500 shadow-emerald-500/20 hover:bg-emerald-600' : 'bg-rose-500 shadow-rose-500/20 hover:bg-rose-600'}`}
                  onClick={handleConfirm}
                >
                  Confirmer
                </button>
              </div>
            </motion.div>
          </Modal>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Advertisement;
